export const EXPERT_MEMBERSHIP_PATH = "/expert/membership";

export const EXPERT_MEMBERSHIP_JOIN_PATH = `${EXPERT_MEMBERSHIP_PATH}#join-requests`;

export function expertMembershipApprovalPath(tab?: string): string {
  const params = tab ? `?tab=${encodeURIComponent(tab)}` : "";
  return `${EXPERT_MEMBERSHIP_PATH}${params}#approval`;
}

export const EXPERT_MEMBERSHIP_APPROVAL_PATH = expertMembershipApprovalPath();
